import { fetcher } from '@commenda/utils';

import { CreateIndirectTaxProductProps, ICommendaProduct } from './types';

type ProductResult = {
  success: boolean;
  data?: ICommendaProduct;
  error?: string;
};

export async function createIndirectTaxProduct(
  body: CreateIndirectTaxProductProps,
  corporationId: number,
  token?: string
): Promise<ProductResult> {
  try {
    const response = await fetcher(
      `new-sales-tax/products/corporation/${corporationId}`,
      { method: 'POST', body },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to create product',
      };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to create product';
    return { success: false, error: errorMessage };
  }
}
